import React from "react";

// components
import Bio from "../Bio";

// assets
import bioImg from "../../../assets/images/SimonMitchell.jpg";

const SimonMBio = (props) => {
  const bioData = {
    title: "Simon Mitchell",
    title2: "Director",
    hashName: "simon-mitchell",
    bio1: `Simon Mitchell has served as a member of our board of directors since September 2024 and a member of our sponsor’s investment committee since October 2024. Mr. Mitchell has served as the Group Head of Business Development for HMC Capital, the parent company of our sponsor, since February 2023. In this role, Mr. Mitchell oversees growth initiatives and corporate development for HMC Capital. Mr. Mitchell has over 27 years’ experience in professional finance roles spanning investment banking research, private equity and accounting. Prior to his role at HMC Capital, Mr. Mitchell served as Managing Director and Head of Investment Research at UBS in Australia and New Zealand between October 2015 to February 2023.  Before this, Mr. Mitchell spent 13 years as a senior investment analyst at UBS and J.P. Morgan, providing investment advice and research to clients regarding the digital infrastructure and logistics real estate sectors. Before joining investment research, Mr. Mitchell spent two years in private equity at Close Brothers in London and three years in corporate restructuring at KPMG LLP (Australia). Mr. Mitchell holds a Bachelor of Commerce/Law from the University of Queensland and is a qualified Chartered Accountant.  Mr. Mitchell is a valuable member of our board of directors because of extensive financial and investment experience, including with digital infrastructure real estate assets.`,
  };
  return (
    <Bio
      srcImg={bioImg}
      title1={bioData.title}
      title2={bioData.title2}
      hashName={bioData.hashName}
      bio1={bioData.bio1}
      closeBio={props.closeBio}
    />
  );
};

export default SimonMBio;
